export const getURLOrigin = (link: string): string => {
  try {
    return new URL(link)?.origin;
  } catch {
    return "";
  }
};
